module.exports = __webpack_public_path__ + "static/media/Jon_P@3x.fb0b97b0.jpg";